/**
 * 课程
 */

export default [
    {
        path: '/teacherIdentifyCourse',
        name: 'teacherIdentifyCourse',
        component: () => import('../../views/course/teacherIdentifyCourse.vue'),
        meta: {
            title: '一站式学生职业规划与就业服务中心'
        }
    },
    {
        path: '/ylStarPlanCourse',
        name: 'ylStarPlanCourse',
        component: () => import('../../views/course/ylStarPlanCourse.vue'),
        meta: {
            title: '宇乐星辰计划'
        }
    },
    {
        path: '/carteerPlanMatchCourse',
        name: 'carteerPlanMatchCourse',
        component: () => import('../../views/course/carteerPlanMatchCourse.vue'),
        meta: {
            title: '职规大赛'
        }
    },
    {
        path: '/k12ServiceCourse',
        name: 'k12ServiceCourse',
        component: () => import('../../views/course/k12ServiceCourse.vue'),
        meta: {
            title: 'K12课程服务'
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/course/course.js